import { useCallback, useEffect, useRef } from 'react'
import { STORE_EVENT_TYPES } from 'lib/enums/shared.enums'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { clearInvoicesLocalFilterValues } from 'lib/utils/Invoices/invoices.utils'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { resetAppState } from 'store/shared.actions'
import { setStoreEvent } from 'store/StoreEvent/storeEvent.reducer'
import useInitializeSSEClientId from './SSE/useInitializeSSEClientId'

const useGlobalEvents = () => {
  const dispatch = useAppDispatch()

  const activeWorkspace = useAppSelector(selectActiveWorkspace)

  // Method called upon workspace change.

  const resetState = useCallback(() => {
    clearInvoicesLocalFilterValues()
    dispatch(resetAppState())
    dispatch(setStoreEvent(STORE_EVENT_TYPES.ACTIVE_WORKSPACE_CHANGE))
  }, [dispatch])

  /* IMPORTANT: The way the 'old' reducers are set up trigger state updates as objects even if for primitive values, which
  can cause confusion as to the stability of dependencies, like activeWorkspace in this case. Updating all reducers to slices,
  on top of saving hundreds of lines, can probably fix this issue, although we need to do the update in order to be sure. */

  const prevActiveWorkspaceRef = useRef(JSON.stringify(activeWorkspace))

  useEffect(() => {
    const serializedActiveWorkspace = JSON.stringify(activeWorkspace)
    if (prevActiveWorkspaceRef.current !== serializedActiveWorkspace) {
      resetState()
      prevActiveWorkspaceRef.current = serializedActiveWorkspace
    }
  }, [resetState, activeWorkspace])

  useInitializeSSEClientId()
}

export default useGlobalEvents
